/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading API Keys. Please wait..." |
*
* @param {Options_Api_Keys_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_loading = /** @type {((inputs?: Options_Api_Keys_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des clés API. Veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel werden geladen. Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento delle chiavi API. Attendi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка ключей API. Пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando claves API. Espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载 API 密钥。请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを読み込んでいます。お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी लोड हो रही हैं। कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando chaves de API. Aguarde...")
	return /** @type {LocalizedString} */ ("Loading API Keys. Please wait...")
});